import { DatePipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import * as ClaimTrackerModels from '@claim-tracker/common/models';

/**
 * Component for displaying a single activity status.
 *
 * @author Jesse Bloomster e020902
 */
@Component({
	selector: 'claim-tracker-activity-status',
	standalone: true,
	templateUrl: './activity-status.component.html',
	styleUrls: ['./activity-status.component.css'],
	imports: [DatePipe]
})
export class ActivityStatusComponent {
	@Input() activityStatus: ClaimTrackerModels.com.aoins.claims.claim.ActivityStatus;
}
